import {
    Component,
    OnInit,
    OnDestroy,
    ChangeDetectorRef,
    AfterViewChecked,
    ViewChild,
    HostListener,
} from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { currentSelectedBsk, getInternalPrefUsr, truncString } from '@core/_utils/tools.utils';
import { currentRequest } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { Router } from '@angular/router';
import { DisplayResultComponent } from '@documalis/displayresult';
import { EditorService } from '@service/editor.service';
import { reqBsk } from '@documalis/_const/const';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { BasketService } from '@service/basket.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, from, lastValueFrom, map, of } from 'rxjs';

@Component({
    selector: 'page-basket-detail',
    styleUrls: ['./page-basket-detail.component.scss'],
    templateUrl: './page-basket-detail.component.html',
})
export class PageBasketDetailComponent implements OnInit, OnDestroy, AfterViewChecked {
    public srchMode = reqBsk;
    public resultList: any[];
    public VariableList: any[];
    public bskVariableList: any[];
    public basketMoveAll: any[];

    public title: string;
    public dockDyn: any[];

    private bskListCount: any[];
    public index: number;
    public listColumns: any[];
    public resultRequest: any;
    public resultDisplay: any;
    public unLockList: any;
    public nbDoc: number;
    public currentBasket: string;
    public error = false;

    public displayListResult = false;
    public infoList: any[];
    public displayFilter: boolean = false;
    public displaySearch: boolean = false;
    public titleRequest: string = '';
    public listRequest: any;
    public isDesktop: boolean = false;

    @ViewChild('dispresult') public dispResult: DisplayResultComponent;
    @ViewChild('dv') public dv: DataView;

    public currentSelectedBsk: currentSelectedBsk;
    public currentRequest: currentRequest;
    public currentFilterAuto: boolean;
    public currentfilterName: string = '';
    private internalPrefUsr: any;
    public visibleListBsk;
    public fetchParam: any;	
    public userList: any[];
    public filterState: {
        state: boolean;
        message: string;
    };
    public allowFullText: boolean = false;

    constructor(
        private cdRef: ChangeDetectorRef,
        protected _messageService: MessagesService,
        private api: ApiV6Service,
        private router: Router,
        public menu: MenuServiceInt,
        public editorService: EditorService,
        private commonService: CommonService,
        private main: LayoutService,
        public basketService: BasketService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.currentSelectedBsk = JSON.parse(JSON.stringify(this.api.bskCurrentSelectedBsk));
        this.userList = JSON.parse(JSON.stringify(this.api.userList));
        let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
        this.internalPrefUsr = getInternalPrefUsr();
        this.VariableList = [...this.api.bskVariable];
        this.bskListCount = JSON.parse(JSON.stringify(this.api.bskListCount));
        this.currentfilterName = this.api.currentfilterName;
        this.affectValue(this.api.bskDocList);
        this.basketService.delay = wInternal.internalcfg;
        this.titleRequest = this.translate.instant('Query_List_1');
        this.fetchParam = {page: 1, displayNext: false};
        if (this.api.bskCurrentSelectedBsk !== null) {
            this.filterState = this.basketService.tools.getFilterState(this.api.bskDocList.nbDoc, this.api.searchWord);            
        } else {
            this.filterState = this.basketService.tools.getFilterState('0', '');                        
        }
        this.api.searchWord = '';
        this.dockDyn = [];
    }

    public ngOnInit() {
        this.index = 0;
        return from(this.menu.getMenu()).pipe(
            map(result => {
                this.allowFullText = this.menu.allowFullText;
                if (this.router.url !== '/page-basket-detail') {
                    // permet de reset le routeroutlet
                    this.router.navigate(['/page-basket-detail']);
                }
                if (this.currentSelectedBsk === null) {
                    this.router.navigate(['/page-basket-list']);
                } else {
                    this.resetParam();
                    this.index = 1;
                }
                this.commonService.checkReset();
             }),
            catchError((error: any) => {
                console.log(error);
                return of(null);
            })).subscribe();
    }

    public ngOnDestroy() {
        this.fetchParam = null;
        this.unlockDoc();
    }

    @HostListener('window:beforeunload')
    onBeforeUnload() {
        this.unlockDoc();
    }

    private affectValue(aData) {
        if (aData === null) {
            return;
        }
        this.currentRequest = aData.currentRequest;
        this.listColumns = aData.listColumns;
        this.bskVariableList = aData.bskVariableList;
        this.basketMoveAll = aData.basketMoveAll;
        this.resultRequest = aData.resultRequest;
        this.resultDisplay = aData.resultDisplay;
        this.setUnlockList(aData.resultDisplay);
        this.resultList = aData.resultList;
        this.infoList = aData.infoList;
        this.nbDoc = aData.nbDoc;
        this.currentBasket = this.currentSelectedBsk.bskLabel;
    }

    private unlockDoc() {
        if (
            this.currentSelectedBsk !== undefined &&
            this.currentSelectedBsk !== null &&
            this.unLockList !== undefined &&
            this.unLockList !== null
        ) {
            if (this.currentSelectedBsk.bskModeAutoLock === true) {
                this.execUnlockDoc();
            }
        }
    }

    private async execUnlockDoc() {
        let wList = '';
        wList = this.formatRequestUnlock();
        const wParams = { Docid: wList };
        if (this.commonService.lockStart === false) {
            try {
                await lastValueFrom(this.api.execUrlAction('unlockdocuments', wParams));
            } catch (error) {
                console.log('PageBasketDetailComponent error');
            }            
        }
        this.commonService.lockList = [];
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    private formatRequestUnlock() {
        let wList = '';
        this.unLockList.forEach((item) => {
            wList = wList + item.doc_docid + ',';
        });
        wList = truncString(wList, 1);
        return wList;
    }

    private resetParam() {
        this.api.bskCurrentSelectedBsk = null;
        this.api.bskVariable = [];
        this.api.bskListCount = null;
        this.api.bskDocList = null;
    }

    private async execSelectBasketDet(
        aCurrentSelectedBsk,
        aVariableList,
        aUpdateFilter,
        aVariableFilter,
        aCurrentFilterAuto,
        aEmptyField,
        aSearchWord,
    ) {        
        let wRes: any;
        this.currentBasket = aCurrentSelectedBsk.bskLabel;
        this.dockDyn = aCurrentSelectedBsk.bskDockDyn;
        this.index = 0;       

        this.basketService.initialize(this.currentSelectedBsk, this.bskListCount);

        wRes = await this.basketService.execSelectBasket(
            aVariableList,
            aUpdateFilter,
            aVariableFilter,
            aCurrentFilterAuto,
            aEmptyField,
            aSearchWord
        );
        if (wRes.success === true) {
            this.currentRequest = wRes.currentRequest;
            this.listColumns = wRes.listColumns;
            this.bskVariableList = wRes.bskVariableList;
            this.basketMoveAll = wRes.basketMoveAll;
            this.resultRequest = wRes.resultRequest;
            this.resultDisplay = wRes.resultDisplay;
            this.unlockDoc();
            this.setUnlockList(wRes.resultDisplay);
            this.resultList = wRes.resultList;
            this.infoList = wRes.infoList;
            this.nbDoc = wRes.nbDoc;
            this.filterState = this.basketService.tools.getFilterState(wRes.nbDoc, aSearchWord);
        }
        this.index = 1;
    }

    private setUnlockList(aList) {
        if (this.currentSelectedBsk.bskModeAutoLock === true) {
            this.unLockList = JSON.parse(JSON.stringify(aList));
            this.commonService.lockList = [...this.unLockList];
        }
    }

    public onClickFilter(event) {
        this.displayFilter = false;
        this.currentfilterName = '';
        if (
            event.variableListRequest !== null &&
            event.variableListRequest !== undefined &&
            event.variableListRequest.length > 0
        ) {
            // Sélection d'un filtre
            this.basketService.currentIdReqentete = event.variableListRequest[0].idReqEntete;
            this.basketService.findFilterName();
            this.basketService.useFilter = true;
            this.currentfilterName = this.basketService.currentfilterName;
            this.VariableList = this.editorService.upateListVariable(event.variableListRequest);
            this.execSelectBasketDet(
                this.currentSelectedBsk,
                this.VariableList,
                true,
                event.variableListRequest,
                event.filterAuto,
                event.emptyField,
                ''
            );
        } else {
            // Aucun filtre
            this.VariableList = [];
            this.basketService.useFilter = false;
            this.execSelectBasketDet(this.currentSelectedBsk, this.VariableList, !event.filterAuto, [], false, true,'');
        }
    }

    public onCloseFilter() {
        this.displayFilter = false;        
    }

    public onFilterSearch() {
        this.displaySearch = true;
    }

    public closeSearch() {
        this.displaySearch = false;
    }

    public onClickSearch($event) {
        this.displaySearch = false;        
        this.VariableList = [];
        this.execSelectBasketDet(this.currentSelectedBsk, this.VariableList, false, [], false, true, $event.searchText);
    }

    public returnList() {
        this.displayListResult = false;
        this.dispResult.goResultDoc();
    }

    public onReturnResult(event) {
        this.dispResult.resetOutlet();
        this.displayListResult = true;
    }

    public onAction(event) {
        if (event === 'validate' || event === 'mailmove' || event === 'move' || event === 'delete') {
            this.setUnlockList(this.dispResult.resultDisplay);
            if (this.dispResult.actionGroup === false) {
                if (event !== 'delete') {
                    if (this.internalPrefUsr.bskNextVal === false) {
                        this.returnList();
                    }
                }
            }    
        }
    }

    public onNextDocs() {}

    public handleChange($event) {}

    public async onFilterBasket() {
        this.displayFilter = true;
        await this.basketService.verifyUserFilter(this.currentSelectedBsk.bskName, this.currentSelectedBsk.bskTypeSearch);
    }
}
